/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainUserRoleString } from '../../entities/domain/UserRoleString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainUserRoleStringSchema = z.enum(['super_manager', 'api_integrator', 'recruiter', 'unknown']) as unknown as ToZod<DomainUserRoleString>